import { castleService } from '../_services'
import { castleConstants, alertConstants } from '../_constants'
import { alertActions } from '../_actions'
export const castleActions = {
  getCastle,
  getCastleSummary,
  saveCastle,
  clearAllMessages,
  updateToolTip
}
function updateToolTip(isExpand){
  return dispatch => {
    dispatch(success(isExpand))
  }
  function success(isExpand) { return { type: castleConstants.UPDATE_TOOL_TIP,isExpand } }
}
function clearAllMessages() {
  return dispatch => {
    dispatch(request())
  }
  function request() { return { type: alertConstants.CLEAR } }
}
function getCastle() {
  return dispatch => {
    dispatch(request())
    castleService.getCastle()
      .then(
        response => {
          console.log(response)
          if ((response && response.message && response.message.indexOf("error")) || (response.error || response.status === 403)) {
            dispatch(failure(response))
          } else {
            dispatch(success(response))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(response) { return { type: castleConstants.GET_REQUEST, response } }
  function success(result) { return { type: castleConstants.GET_SUCCESS, result } }
  function failure(error) { return { type: castleConstants.GET_FAILURE, error } }
}

function getCastleSummary() {
  return dispatch => {
    dispatch(request())
    castleService.getCastleSummary()
      .then(
        response => {
          console.log(response)
          if (response && response.message && response.message.indexOf("error")) {
            dispatch(failure(response))
          } else {
          dispatch(success(response))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request() { return { type: castleConstants.SUMMARY_REQUEST } }
  function success(summary) { return { type: castleConstants.SUMMARY_SUCCESS, summary } }
  function failure(error) { return { type: castleConstants.GET_FAILURE, error } }
}

function saveCastle(castle) {
  return dispatch => {
    dispatch(request())
   
    castleService.saveCastle(castle)
      .then(
        response => {
          console.log(response)
          dispatch(success(response))
          dispatch(getCastleSummary())
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(response) { return { type: castleConstants.ADD_REQUEST, response } }
  function success(result) { return { type: castleConstants.ADD_SUCCESS, result } }
  function failure(error) { return { type: castleConstants.ADD_FAILURE, error } }
}
